import storesApi from "../../api/stores";

const emptyStore = {
  cityId: null,

  avatar: null,
  name: "",
  legalName: "",
  categoryId: null,
  labelIds: [],

  logo: null,
  description: "",
  website: "",
  phone: "",
  email: "",

  location: {
    lat: "",
    lng: "",
    street: "",
    houseNumber: "",
    zipCode: "",
    city: ""
  },

  useOpeningHoursText: false,
  openingHoursText: "",

  openingHours: {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  }
};

const parseData = data => {
  let result = data;

  if (data.useOpeningHoursText === true) {
    data.openingHours = data.openingHoursText;
  }
  delete data.useOpeningHoursText;
  delete data.openingHoursText;

  return result;
};

const state = () => ({
  id: null,
  data: emptyStore
});

const getters = {};

const actions = {
  create({ state }) {
    return storesApi.create(parseData(state.data));
  },

  fetchOne({ state }, storeId) {
    return new Promise((resolve, reject) =>
      storesApi
        .getOne(storeId)
        .then(result => {
          state.id = result._id;
          delete result._id;

          result.useOpeningHoursText = typeof result.openingHours === "string";
          result.openingHoursText = result.useOpeningHoursText
            ? result.openingHours
            : "";
          result.openingHours = result.useOpeningHoursText
            ? emptyStore.openingHours
            : result.openingHours;

          state.data = result;
          resolve();
        })
        .catch(e => reject(e))
    );
  },

  save({ state }) {
    return storesApi.update(state.id, parseData(state.data));
  }
};

const mutations = {
  clear(state) {
    state.id = null;
    state.data = emptyStore;
  },

  setCity(state, cityId) {
    state.data.cityId = cityId;
  },

  setAvatar(state, avatar) {
    state.data.avatar = avatar;
  },
  setName(state, name) {
    state.data.name = name;
  },
  setLegalName(state, legalName) {
    state.data.legalName = legalName;
  },
  setCategory(state, categoryId) {
    state.data.categoryId = categoryId;
  },
  setLabels(state, labelIds) {
    state.data.labelIds = labelIds;
  },

  setLogo(state, logo) {
    state.data.logo = logo;
  },
  setDescription(state, description) {
    state.data.description = description;
  },
  setWebsite(state, website) {
    state.data.website = website;
  },
  setPhone(state, phone) {
    state.data.phone = phone;
  },
  setEmail(state, email) {
    state.data.email = email;
  },

  setLat(state, lat) {
    state.data.location.lat = lat;
  },
  setLng(state, lng) {
    state.data.location.lng = lng;
  },
  setStreet(state, street) {
    state.data.location.street = street;
  },
  setHouseNumber(state, houseNumber) {
    state.data.location.houseNumber = houseNumber;
  },
  setZipCode(state, zipCode) {
    state.data.location.zipCode = zipCode;
  },
  setCityName(state, cityName) {
    state.data.location.city = cityName;
  },

  setUseOpeningHoursText(state, useOpeningHoursText) {
    state.data.useOpeningHoursText = useOpeningHoursText;
  },
  setOpeningHoursText(state, openingHoursText) {
    state.data.openingHoursText = openingHoursText;
  },

  setMonday(state, monday) {
    state.data.openingHours.monday = monday;
  },
  setTuesday(state, tuesday) {
    state.data.openingHours.tuesday = tuesday;
  },
  setWednesday(state, wednesday) {
    state.data.openingHours.wednesday = wednesday;
  },
  setThursday(state, thursday) {
    state.data.openingHours.thursday = thursday;
  },
  setFriday(state, friday) {
    state.data.openingHours.friday = friday;
  },
  setSaturday(state, saturday) {
    state.data.openingHours.saturday = saturday;
  },
  setSunday(state, sunday) {
    state.data.openingHours.sunday = sunday;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
